import KeyValuePair from '@/modules/core/support/KeyValuePair'

/**
 * Módulo de una aplicación
 *
 * Representa una sección, módulo o funcionalidad de una de las aplicaciones
 * registradas en el enrutador.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class AppModule {
    public id = 0
    public name = ''
    public key = ''

    public get isNew () {
        return !this.id
    }

    public serialize () {
        return {
            name: this.name,
            key: this.key,
        }
    }

    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), data)
    }
}
